module.exports = __webpack_public_path__ + "img/mercedes.5c9916d2.webp";